
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/om-raadgivningen",
      function () {
        return require("private-next-pages/om-raadgivningen/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/om-raadgivningen"])
      });
    }
  